import React from 'react';

import * as Types from 'types';

type Props = {
  user: Types.LoggedInUser;
  className?: string;
  target?: string;
  style?: React.CSSProperties;
  linkStyle?: React.CSSProperties;
};

export const InlinedUser: React.FC<Props> = ({
  user,
  className,
  target,
  style,
  linkStyle,
}) => {
  return (
    <a
      className={`inlined-user inlined-user--lead ${
        className ? className : ''
      }`}
      href={user.url}
      style={style}
      target={target}
    >
      <img src={user.avatarUrl} alt={`${user.name} avatar`} />
      <span className='link-border' style={linkStyle}>
        {user.name}
      </span>
    </a>
  );
};
